import { jsx } from "react/jsx-runtime";
import cn from "clsx";
const Table = ({ className, ...props }) => /* @__PURE__ */ jsx(
  "table",
  {
    className: cn(
      "_not-prose",
      // for nextra-theme-blog
      "_block _overflow-x-auto",
      className
    ),
    ...props
  }
);
export {
  Table
};
